const data = [
  {
    key: 1,
    goal: "Learn React in 2 days",
    challenges: "Don't find a trainer",
    flow: "Assign a trainer, get support from the trainer",
    tagsAndLinks: "Link",
    date: "28-March-2024",
  },
  {
    key: 2,
    goal: "Build a personal website",
    challenges: "Lack of design skills",
    flow: "Study design principles, use templates",
    tagsAndLinks: "Link",
    date: "28-March-2024",
  },
  {
    key: 3,
    goal: "Read 10 books this year",
    challenges: "Lack of time",
    flow: "Schedule reading time, use audiobooks",
    tagsAndLinks: "Link",
    date: "28-March-2024",
  },
  {
    key: 4,
    goal: "Start a side project",
    challenges: "Busy schedule",
    flow: "Plan project milestones, allocate time",
    tagsAndLinks: "Link",
    date: "28-March-2024",
  },
  {
    key: 5,
    goal: "Learn a new language",
    challenges: "Difficulty staying consistent",
    flow: "Practice daily, use language learning apps",
    tagsAndLinks: "Link",
    date: "28-March-2024",
  },
];

export default data;
